import React, { useState, useRef, useEffect } from 'react';
import './UserProfile.css';
import { useAuth } from '../context/AuthContext'; //

const UserProfile = () => {
    const { user } = useAuth();
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    if (!user) {
        return <div className="user-profile"><div className="profile-picture-placeholder" /></div>;
    }

    const getRoleClassName = (role) => {
        return `role-${role.replace('ROLE_', '').toLowerCase()}`;
    };

    return (
        <div className="user-profile" ref={dropdownRef}>
            <button onClick={() => setDropdownOpen(!isDropdownOpen)} className="profile-button">
                <img src={user.picture} alt="User profile" className="profile-picture" />
            </button>

            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <div className="dropdown-header">
                        <strong>{user.name}</strong>
                        <small>{user.email}</small>
                    </div>

                    <div className="dropdown-roles">
                        {user.roles && user.roles.map(role => (
                            <span key={role} className={`dropdown-role ${getRoleClassName(role)}`}>
                                {role.replace('ROLE_', '')}
                            </span>
                        ))}
                    </div>

                    <ul className="dropdown-list">
                        <li>
                            <form action="/logout" method="post" style={{ margin: 0 }}>
                                <button type="submit" className="logout-link-button">Logout</button>
                            </form>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserProfile;